import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

import { CategoryMultiselectComponent } from './category-multiselect.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MultiselectDropdownModule
  ],
  exports: [
    CategoryMultiselectComponent
  ],
  declarations: [
    CategoryMultiselectComponent
  ]
})
export class CategoryMultiselectModule {

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+category/category-multiselect/category-multiselect.module.ts